var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ArrowUpSmallSvg = /* @__PURE__ */ __name(function ArrowUpSmallSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M21.938 20.147l-5.938-5.938-5.938 5.938-1.569-1.573 7.507-7.507 7.507 7.507-1.569 1.573z"
  }));
}, "ArrowUpSmallSvg");
var ArrowUpSmallIcon = /* @__PURE__ */ __name(function ArrowUpSmallIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ArrowUpSmallSvg
  }, props));
}, "ArrowUpSmallIcon");
export {
  ArrowUpSmallIcon
};
